












import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { logout } from '../auth'
import consts from '../consts'

@Component
export default class GuestTopBar extends Vue {
  @Prop() private showLogout!: boolean;

  private logout() {
    logout();
    this.$router.push({ name: 'login' });
  }
}
